import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer id="contact" className="bg-gray-900 text-white section-padding">
      <div className="container-custom">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <p className="text-gray-400">
              We craft brands that connect, inspire, and lead. Your Digital Success Partner.
            </p>
          </div>
          <div>
            <h3 className="font-normal mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#features" className="hover:text-white transition-colors">Logo Design</a></li>
              <li><a href="#features" className="hover:text-white transition-colors">Social Media Marketing</a></li>
              <li><a href="#features" className="hover:text-white transition-colors">Video Production</a></li>
              <li><a href="#features" className="hover:text-white transition-colors">Event Branding</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-normal mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#about" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="#vision" className="hover:text-white transition-colors">Vision & Mission</a></li>
              <li><a href="#values" className="hover:text-white transition-colors">Core Values</a></li>
              <li><a href="/portfolio" className="hover:text-white transition-colors">Portfolio</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-normal mb-4">Contact Info</h3>
            <div className="space-y-3 text-gray-400">
              <p>Email: info@curiye.com</p>
              <p>Phone: +252 61 871 5418</p>
              <p>Location: Mogadishu, Somalia</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2025 Curiye Advert. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
